import { SET_CALCULATION_METADATA } from 'src/reduxActions/actionNameEnums';
import { CalculationFunction } from 'src/components/pages/chartBuilder/createQueryComponents/dataSetupContainerPart/calculationMetadataTypes';

export interface CalculationMetadataState {
    functions: CalculationFunction[];
    lastFetched: { reportType: string } | null;
}

const initialState: CalculationMetadataState = {
    functions: [],
    lastFetched: null,
};

const calculationMetadataReducer = (
    state: CalculationMetadataState = initialState,
    action: any,
): CalculationMetadataState => {
    switch (action.type) {
        case SET_CALCULATION_METADATA:
            return {
                ...state,
                functions: action.payload.functions,
                lastFetched: action.payload.lastFetched,
            };

        default:
            return state;
    }
};

export default calculationMetadataReducer;

